import Highway from '@dogstudio/highway'
import modular from 'modujs'

import * as modules from './modules'
import FadeTransition from './modules/FadeTransition'
import Map from './modules/Map'

import { bindHighwayPerf, perfTime } from './utils/perf'
import { getPrefetchDuration, initPrefetch, refreshPrefetch, wasPrefetched } from './utils/prefetch'
import { classesInjection, rewriteLinks } from './utils/transitions'


const Modular = modular
const app = new Modular({
  modules
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted () {
    const end = perfTime('renderer.onEnterCompleted')

    const endRewrite = perfTime('renderer.rewriteLinks')
    rewriteLinks()
    endRewrite()

    const endPrefetch = perfTime('renderer.refreshPrefetch')
    refreshPrefetch()
    endPrefetch()

    const endInit = perfTime('renderer.app.init')
    app.init(app)
    endInit()

    end()
    return this
  }
}

const init = () => {
  classesInjection()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer
    },
    transitions: {
      default: FadeTransition
    }
  })

  bindHighwayPerf(H, { wasPrefetched, getPrefetchDuration })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    const end = perfTime('app.destroy')
    app.destroy()
    end()
  })

  window.H = H
  new Map()
  initPrefetch()

}

document.addEventListener('DOMContentLoaded', init)
